import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject, Injector } from '@angular/core';
import { StorageService } from '../services/storage.service';
import { EncryptionService } from '../services/encryption.service';
import { AuthService } from '../services/auth.service';
import { Constants } from '../shared/constants';
import { environment } from '../../../environments/environment';

export const tokenInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const storageService = inject(StorageService);
  const encryptionService = inject(EncryptionService);
  const injector = inject(Injector);

  const ENCRYPTION_KEY = `${environment.app}-${environment.appId}`;

  // Retrieve and decrypt the token with error handling
  let token: string | null = null;
  const encryptedToken = storageService.get(Constants.STORAGE_VARIABLES.TOKEN);

  if (encryptedToken) {
    try {
      token = encryptionService.decrypt(
        ENCRYPTION_KEY,
        encryptedToken,
        Constants.STORAGE_VARIABLES.TOKEN,
      );
    } catch (error) {
      // Decryption failed - logout user and remove invalid token
      console.error('Token decryption failed:', error);
      const authService = injector.get(AuthService);
      authService.logout();
      token = null;
    }
  }

  // If token exists, clone the request and add Authorization header
  if (token) {
    request = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(request);
};
